import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { AssetTypeFieldsRevisionSettingsDetailViewTopBar } from "./TopBar"

export const assetTypeFieldsRevisionSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: AssetTypeFieldsRevisionSettingsDetailViewTopBar,
}
